module.exports = __webpack_public_path__ + "static/img/employee-04.c9fee83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-04.png
// module id = PwOK
// module chunks = 2